import { render, staticRenderFns } from "./baseExam.vue?vue&type=template&id=6af3a74b&scoped=true"
import script from "./baseExam.vue?vue&type=script&lang=js"
export * from "./baseExam.vue?vue&type=script&lang=js"
import style0 from "./baseExam.vue?vue&type=style&index=0&id=6af3a74b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3a74b",
  null
  
)

export default component.exports